import type { ReactNode } from "react";
import { Grid2, Typography } from "@mui/material";

const labelSx = {
  fontWeight: "bold",
  color: "text.primary",
  mr: 0.5
} as const;

type ScheduleResourceBookingMetaFieldProps = Readonly<{
  label: string;
  testId: string;
  children: ReactNode;
  endAdornment?: ReactNode;
}>;

/** Compact inline meta row: bold label + value on one line, flush left. */
export function ScheduleResourceBookingMetaField({
  label,
  testId,
  children,
  endAdornment
}: ScheduleResourceBookingMetaFieldProps) {
  return (
    <Grid2
      container
      alignItems="center"
      gap={0.5}
      data-testid={testId}
      sx={{ width: "100%", pl: 0, flexWrap: "nowrap" }}
    >
      <Typography variant="body1" color="text.secondary">
        <Typography component="span" sx={labelSx}>
          {label}
        </Typography>{" "}
        {children}
      </Typography>
      {endAdornment}
    </Grid2>
  );
}
